import React from 'react';
import clsx from 'clsx';
import styles from './ReferralInstructionSteps.module.css';
import {ReferralStep, ReferralStepProps} from './Step';
import {useDevice} from '../../Atoms';

type ReferralInstructionStepsProps = {
  steps: ReferralStepProps[];
};

export const ReferralInstructionSteps = ({
  steps,
}: ReferralInstructionStepsProps) => {
  const {isMobile, isDesktop} = useDevice();

  return (
    <ol
      className={clsx(styles.root, styles.grid, {
        [styles.gridMobile]: isMobile,
        [styles.gridDesktop]: isDesktop,
      })}
    >
      {steps.map((step) => (
        <li key={step.header} className={styles.item}>
          <ReferralStep
            icon={step.icon}
            colorPair={step.colorPair}
            header={step.header}
            body={step.body}
          />
        </li>
      ))}
    </ol>
  );
};
